module.exports = __webpack_public_path__ + "static/NOI0-22eafb7e2b77467100fa0d41252bf8a6.jpg";